import React from 'react';
import './AboutUsSection.css';

const AboutUsSection = () => {
  return (
    <section className="about-us-section">
      {/* Parallax Background */}
      <div className="static-background" />

      {/* Foreground Layer */}
      <div className="foreground-layer">
        <img
          src="/images/foreground2.png"
          alt="Foreground"
          className="foreground-image"
        />
        <div className="about-text over-image">
          <h2>درباره ما</h2>
          <p>
            در گوهر صدف، ما به قدرت هنر دست‌ساز اعتقاد داریم.
            هر محصول با دقت طراحی و توسط صنعتگران ماهر با استفاده از مواد طبیعی و پایدار ساخته می‌شود.
            هدف ما آوردن گرما، اصالت و جذابیت به زندگی شماست.
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutUsSection;
